import { getUrlParam } from './url.utils';

/**
 * The exhibitor that invited this registration. Voucher links carry `?exi=<exhibitorId>`; once the
 * order exists the id lives on its ExhibitorInvite order extra and the URL may no longer have it.
 * Order extra wins, URL param is the fallback. Returns a positive integer or null.
 */
export const getInviteExhibitorId = order => {
  const fromOrder = order?.orderExtra?.find(x => x.name == 'ExhibitorInvite')?.value;
  const raw = fromOrder || getUrlParam('exi');
  const id = parseInt(raw);
  return Number.isInteger(id) && id > 0 ? id : null;
};

/**
 * Person types of an invited registration: the order's own, plus the `pti` from the voucher link.
 */
export const getInvitePersonTypeIds = order => {
  const personTypes = order?.personTypes?.map(x => x.personTypeId) ?? [];
  const pti = parseInt(getUrlParam('pti'));
  if (Number.isInteger(pti) && !personTypes.some(x => x == pti)) personTypes.push(pti);
  return personTypes;
};

/**
 * Query string telling the capacity endpoints which exhibitor's held seats this visitor may use.
 * Empty when the registration did not come through a voucher link.
 */
export const capacityQuery = (order, prefix = '&') => {
  const exhibitorId = getInviteExhibitorId(order);
  return exhibitorId ? `${prefix}exi=${exhibitorId}&ptis=${getInvitePersonTypeIds(order).join(',')}` : '';
};
